import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { setMapTooltipIsVisible } from "../../../stateManagement/reducers/MapTooltipSlice";
import { getBasicObjectTypeLayer, getAllObjectsLayer } from "../../../widgets/map/mapFeatures/layers";
import { copyInfoFromTooltip, showMapTooltip } from "../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { MapDataTable } from "../../../widgets/map/mapAddons/mapDataTable";
import { MapOverlayWidget } from "../../../widgets/map/mapAddons/mapOverlayWidget";
import { MapTooltip } from "../../../widgets/map/mapAddons/mapTooltip";
import { roadCategoryFiltersOptions } from "../../../widgets/map/mapAddons/mapOverlayWidget/roadCategorySegmentsOverlay";
import { mapLayersDict } from "../mapLayersDict";
import { setHighContrastModeIsEnabled } from "../../../stateManagement/reducers/ContentHeaderSlice";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export function MapRoadCategorySegments() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const objectTypeName = "RoadCategorySegments"
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const { wmsServer, wmsVersion, workspace } = getItemWebStorage('currentConfig')
    const chosenCategoriesIds = useAppSelector(state => state.roadCategorySegments.chosenCategoriesIds)
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)

    // определение неизменяемых слоев карты
    const roadsLayer = getAllObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, caption } = mapLayersDict[objectTypeName] ?? {}
        caption && setMapTitle(`Карта «${caption}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        let roadCategoryFiltersTempArray = Object.entries(chosenCategoriesIds).filter(([key, value]: any) => value === true).map(([key, value]) => key)
        let roadCategoryFiltersArray = roadCategoryFiltersTempArray.map(key => roadCategoryFiltersOptions[key].categoryId).flat()
        const layerFilter = `RelativeCategoryId in (${roadCategoryFiltersArray?.join(',')})`
        const objectTypeLayer = getBasicObjectTypeLayer(mapLayer, wmsServer, wmsVersion, workspace, layerFilter)
        setAdditionalLayers([objectTypeLayer])
        dispatch(setHighContrastModeIsEnabled(true))
        return () => {
            dispatch(setHighContrastModeIsEnabled(false))
        }
    }, [objectTypeName, chosenCategoriesIds]);

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, 'roadCategorySegments', additionalLayers[0], map)
        const activeTooltipClick = (event: any) => copyInfoFromTooltip()
        map?.on("pointermove", pointerMoveFunc)
        map?.on("singleclick", activeTooltipClick)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                map?.un("singleclick", activeTooltipClick)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={objectTypeName} type="map" />
            <div className="map-widget-with-toast">
                <MapTooltip type={objectTypeName} />
                <MapWidget additionalLayers={additionalLayers} permanentLayers={permanentLayers} mapEventHandlers={mapEventHandlers} mapSizeClass={tableUnderMapIsShown ? 'road-bed-layers-map-container' : null} />
                <MapOverlayWidget />
                {tableUnderMapIsShown && <MapDataTable className="road-category-segments-under-map-table" />}
            </div>
        </>
    )
}
